<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span 2
      h1 Canales de distribución verde

    img(data-aos="fade-up")(src="@/assets/curso/temas/tema2/1.png", alt="Imagen decorativa")

    .row.justify-content-center
      .col-lg-10(data-aos="fade-down")
        div.banner-text.bg-white
          p.mb-0 Los canales de distribución verde buscan mover productos de forma eficiente y con el menor impacto ambiental posible. Incorporan prácticas sostenibles como transporte limpio, empaques ecológicos y logística responsable. Ayudan a reducir la huella de carbono y mejoran la imagen de marca ante consumidores conscientes. Además, fortalecen cadenas de valor más justas, éticas y respetuosas con el entorno.

    Separador
    #t_2_1(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido
      h3 2.1 Concepto

    .row.justify-content-center.align-items-center
      .col-8.col-md-6.col-lg-3
        img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema2/2.png", alt="Imagen decorativa", data-aos="fade-up")
      .col-lg-9
        p Los canales de distribución verde son sistemas logísticos que integran prácticas sostenibles en el proceso de traslado de productos, con el objetivo de minimizar el impacto ambiental. Esto incluye el uso de medios de transporte ecológicos (como vehículos eléctricos o bicicletas de reparto), rutas optimizadas para reducir emisiones, y materiales de empaque reciclables o biodegradables. Estas acciones permiten reducir la huella de carbono, el consumo energético y la generación de residuos.
        .cajon.color-acento-contenido.p-4
          p.mb-0 Además, estos canales fomentan alianzas con proveedores y distribuidores que comparten valores ambientales, promoviendo una red coherente con los principios de la economía circular. No solo se prioriza la eficiencia operativa, sino también la responsabilidad social y ambiental, lo que contribuye a una distribución más limpia, ética y alineada con los objetivos del desarrollo sostenible.

    Separador
    #t_2_2(data-aos='zoom-in-left').titulo-segundo.color-acento-contenido
      h3 2.2 Clasificación

    .row.justify-content-center.align-items-center.mb-5
      .col-8.col-md-6.col-lg-3
        img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema2/3.png", alt="Imagen decorativa", data-aos="fade-up")
      .col-lg-9
        p En el contexto de los negocios sostenibles, la selección del canal de distribución es un aspecto clave para asegurar la coherencia con los principios ambientales. Los canales verdes no solo deben garantizar la llegada del producto al consumidor, sino que también deben minimizar el impacto ambiental en cada etapa del proceso. Esta clasificación permite identificar diferentes estrategias que pueden adoptar las organizaciones para distribuir de manera responsable, eficiente y alineada con la sostenibilidad.
        p A continuación, se describen los principales tipos de canales de distribución verdes, junto con sus características y ejemplos prácticos:

    .row.justify-content-center.z-2
      .col-xl-10
        h4(data-aos='zoom-in-right').mb-5
          span.decorated-title Tipos de canales de distribución verdes

        AcordionA(tipo="a" clase-tarjeta="tarjeta tarjeta--primario-p20")
          .row.justify-content-center.align-items-center.ps-5(titulo="Directos")
            .col-lg-8
              p El producto va del productor al consumidor final sin intermediarios. Esto permite un mayor control sobre las prácticas ambientales, la reducción de emisiones por transporte y la eliminación de embalajes innecesarios.
              p.mb-0 <strong>Ejemplo:</strong> venta <em>online</em> de productos orgánicos directamente desde la finca hasta el cliente, utilizando empaques biodegradables y transporte local.
            .col-sm-8.col-lg-4
              figure
                img(src='@/assets/curso/temas/tema2/4.png', alt='Imagen de acompañamiento')

          .row.justify-content-center.align-items-center.ps-5(titulo="Indirectos")
            .col-lg-8
              p Involucran intermediarios (mayoristas, minoristas, distribuidores), pero estos deben operar bajo estándares sostenibles, como certificaciones verdes o prácticas responsables.
              p.mb-0 <strong>Ejemplo:</strong> distribuidores y tiendas que comercializan productos con sellos ecológicos, como supermercados que exigen criterios ambientales a sus proveedores.
            .col-sm-8.col-lg-4
              figure
                img(src='@/assets/curso/temas/tema2/5.png', alt='Imagen de acompañamiento')
                
          .row.justify-content-center.align-items-center.ps-5(titulo="Híbridos")
            .col-lg-8
              p Combinan los dos modelos anteriores, aprovechando las ventajas del canal directo (cercanía y control ambiental) y del canal indirecto (mayor alcance y cobertura de mercado).
              p.mb-0 <strong>Ejemplo:</strong> empresas que venden en tiendas físicas ecoeficientes y también a través de plataformas digitales sostenibles que promueven entregas neutras en carbono.
            .col-sm-8.col-lg-4
              figure
                img(src='@/assets/curso/temas/tema2/6.png', alt='Imagen de acompañamiento')

    .fullwidth-bg.fullwidth-bg--1
    Separador
    #t_2_3(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido
      h3 2.3 Características

    .row.justify-content-center.align-items-center.mb-5.z-2
      .col-md-10.col-xl-6.mb-4.mb-xl-0
        .p-4.py-xl-5.bg-waves.bg-waves--gris-decorado
          p.mb-0 En el contexto de la logística verde, ciertos principios resultan fundamentales para alcanzar una operación más sostenible. Entre ellos destacan la eficiencia energética, la transparencia en la gestión ambiental, la cooperación entre organizaciones y la flexibilidad ante los cambios del entorno. Estos elementos no solo ayudan a minimizar el impacto ecológico, sino que también fortalecen la competitividad y la responsabilidad empresarial.

      .col-md-10.col-xl-6
        .py-4.bg-slider
          .row.justify-content-center.align-items-center.factores-slider.z-2
            .col-auto
              SlyderF(columnas="col-12")
                .tarjeta.tarjeta--blanca.p-4
                  p.mb-0 Eficiencia energética: se refiere al uso de tecnologías limpias y renovables tanto en el transporte como en el almacenamiento, con el fin de reducir el consumo de combustibles fósiles y las emisiones contaminantes. Ejemplos incluyen camiones eléctricos, iluminación LED y sistemas de climatización eficientes en bodegas.
                .tarjeta.tarjeta--blanca.p-4
                  p.mb-0 Transparencia: implica mantener un control riguroso y accesible sobre toda la documentación relacionada con el impacto ambiental de las operaciones logísticas. Esto facilita auditorías, reportes de sostenibilidad y la toma de decisiones más conscientes por parte de los actores involucrados.
                .tarjeta.tarjeta--blanca.p-4
                  p.mb-0 Cooperación interorganizacional: consiste en establecer alianzas estratégicas entre empresas para compartir infraestructuras, rutas de transporte o sistemas de devolución de productos, lo cual reduce costos, duplicidades y emisiones. Por ejemplo, dos compañías pueden utilizar un mismo centro de distribución ecológico.
                .tarjeta.tarjeta--blanca.p-4
                  p.mb-0 Flexibilidad: se refiere a la capacidad de la cadena logística para adaptarse a nuevas regulaciones ambientales, innovaciones tecnológicas o cambios en las preferencias del consumidor que demandan productos y servicios más sostenibles. Esto asegura la competitividad en un entorno en constante evolución.
        
    .row.justify-content-center.align-items-center.z-2.mb-5
      .col-xl-10
        .titulo-sexto.color-acento-contenido.mb-4
          h5 Figura 7.
          span Características de la distribución sostenible
        img.d-sm-none.mb-2(data-aos="fade-up", src='@/assets/curso/temas/tema2/7-mob.svg', alt='En la imagen se muestra las características de la logística verde: Eficiencia energética: uso de tecnologías limpias en transporte y almacenamiento. Transparencia: gestión clara del impacto ambiental mediante documentación. Cooperación interorganizacional: alianzas para compartir recursos y reducir emisiones. Flexibilidad: adaptación a normas ambientales y cambios del mercado sostenible.')
        img.d-none.d-sm-block.mb-2(data-aos="fade-up", src='@/assets/curso/temas/tema2/7.svg', alt='En la imagen se muestra las características de la logística verde: Eficiencia energética: uso de tecnologías limpias en transporte y almacenamiento. Transparencia: gestión clara del impacto ambiental mediante documentación. Cooperación interorganizacional: alianzas para compartir recursos y reducir emisiones. Flexibilidad: adaptación a normas ambientales y cambios del mercado sostenible.')
        figcaption <strong>Fuente:</strong> SENA, 2025.

    p.mb-5 Se recomienda revisar el siguiente video: Canales de distribución y comercialización según la tecnología para la venta.
    figure
      .video.mb-2
        iframe(width="560" height="315" src="https://www.youtube.com/embed/YzMfN8fHlP8" title="Canales de distribución y comercialización según la tecnología para la venta" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen)
      figcaption Video: canales de distribución y comercialización según la tecnología para la venta

    Separador
    #t_2_4(data-aos='zoom-in-left').titulo-segundo.color-acento-contenido
      h3 2.4 Sistema

    p.mb-5 El sistema verde se basa en la integración de tecnologías, herramientas de control y relaciones estratégicas que permiten hacer más sostenible toda la operación logística. Esto no solo reduce el impacto ambiental, sino que también mejora la eficiencia operativa y fortalece la imagen responsable de la empresa.

    h4(data-aos='zoom-in-right').mb-5
      span.decorated-title Sistema de distribución verde

    .row.justify-content-center.align-items-center
      .col-lg-4.d-none.d-xl-block
        figure
          img(src='@/assets/curso/temas/tema2/10.png', alt='Imagen de acompañamiento', data-aos="fade-up")
      .col-xl-8.p-3.bg-slider.rounded-3
        .tarjeta.tarjeta--blanca.p-4.py-5
          SlyderA(tipo="b")
            .row.align-items-center.justify-content-center
              .col-sm-10.col-lg-8
                h5.mb-4 Tecnologías limpias
                p Implementación de energías renovables o vehículos con baja o nula emisión de carbono.
                p.mb-4.mb-lg-0 <strong>Ejemplo</strong>: flota de camiones eléctricos o con biodiésel para el reparto urbano.
              .col-sm-8.col-lg-3.col-xl-2
                figure
                  img.mb-4.mb-lg-0.w-81(src='@/assets/curso/temas/tema2/11.svg', alt='Imagen ilustrativa')
                  
            .row.align-items-center.justify-content-center
              .col-sm-10.col-lg-8
                h5.mb-4 Sistemas de monitoreo
                p Uso de <em>software</em> y sensores para medir consumo energético, rutas, emisiones y desempeño.
                p.mb-4.mb-lg-0 <strong>Ejemplo</strong>: plataforma digital que mide en tiempo real la huella de carbono por trayecto.
              .col-sm-8.col-lg-3.col-xl-2
                figure
                  img.mb-4.mb-lg-0.w-81(src='@/assets/curso/temas/tema2/12.svg', alt='Imagen ilustrativa')
                  
            .row.align-items-center.justify-content-center
              .col-sm-10.col-lg-8
                h5.mb-4 Alianzas logísticas
                p Cooperación con aliados que poseen certificaciones ambientales o políticas verdes.
                p.mb-4.mb-lg-0 <strong>Ejemplo</strong>: acuerdo con proveedores certificados en sostenibilidad para distribución conjunta.
              .col-sm-8.col-lg-3.col-xl-2
                figure
                  img.mb-4.mb-lg-0.w-81(src='@/assets/curso/temas/tema2/13.svg', alt='Imagen ilustrativa')
    Separador
    #t_2_5(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido
      h3 2.5 Estructura

    p.mb-5 Una estructura de logística verde debe estar diseñada para minimizar el impacto ambiental en cada eslabón de la cadena de suministro. Para ello, es clave articular una red colaborativa, centros de distribución ecoeficientes y herramientas tecnológicas que optimicen los recursos y reduzcan emisiones.

    .row.justify-content-center.align-items-center.z-2
      .col-xl-10         
        .titulo-sexto.color-acento-contenido(data-aos="zoom-in-right")
          h5 Tabla 1.
          span Estructura de logística verde
        .tabla-a.color-primario.mb-5(data-aos="zoom-in-right")
          table
            caption 
              p <b>Fuente:</b> Adaptada de Peña & Londoño, 2022.
            thead
              tr
                th.col-3(style="background-color: #F2FBE4") Elemento
                th.col-4(style="background-color: #F2FBE4") Descripción
                th.col-5(style="background-color: #F2FBE4") Ejemplo
            tbody
              tr
                td Red colaborativa.
                td Integración de todos los actores logísticos con compromiso ambiental: productores, proveedores, transportistas y distribuidores.
                td Una red de empresas agrícolas que comparten transporte de productos orgánicos para reducir emisiones.
              tr
                td Centros de distribución verdes.
                td Infraestructura con diseño sostenible, uso eficiente de recursos, reciclaje y tecnologías limpias.
                td Un almacén que usa paneles solares, sistema de recolección de agua lluvia y clasificación de residuos.
              tr
                td Plataformas digitales.
                td Sistemas tecnológicos para planificar rutas, gestionar inventarios y evitar desplazamientos innecesarios.
                td Aplicación móvil que agrupa entregas por zona geográfica para reducir recorridos.

    .fullwidth-bg.fullwidth-bg--1
    Separador
    #t_2_6(data-aos='zoom-in-left').titulo-segundo.color-acento-contenido
      h3 2.6 Métodos de selección

    img(data-aos="fade-up")(src="@/assets/curso/temas/tema2/14.png", alt="Imagen decorativa")

    .row.justify-content-center.mb-5
      .col-lg-10(data-aos="fade-down")
        div.banner-text.bg-white
          p.mb-0 En la búsqueda de una logística sostenible, es fundamental contar con métodos que permitan evaluar y seleccionar las mejores alternativas desde una perspectiva ambiental. Estos métodos facilitan la identificación de opciones que no solo optimizan costos y eficiencia, sino que también minimizan el impacto ecológico. Entre los principales enfoques se encuentran:

    .p-4.bg-slider.rounded-3.mb-5
      .tarjeta.tarjeta--blanca.p-4.py-5
        SlyderA(tipo="b")
          .row.align-items-center.justify-content-center
            .col-sm-10.col-lg-7.col-xl-6.mb-5.mb-lg-0
              h4 Evaluación de huella de carbono
              p.mb-4 Consiste en medir y comparar las emisiones de gases de efecto invernadero generadas por diferentes procesos o actividades dentro de la cadena logística. Esta evaluación permite priorizar y seleccionar alternativas que reduzcan el impacto ambiental, como optar por transportes más limpios o materiales con menor impacto en su ciclo de vida.
            .col-sm-8.col-lg-5
              figure
                img(src='@/assets/curso/temas/tema2/15.png', alt='Imagen ilustrativa', data-aos="fade-left")

          .row.align-items-center.justify-content-center
            .col-sm-10.col-lg-7.col-xl-6.mb-5.mb-lg-0
              h4 Certificaciones ambientales
              p.mb-4 Son reconocimientos oficiales que garantizan que una organización o proceso cumple con estándares internacionales de gestión ambiental, como ISO 14001 o EMAS. Estas certificaciones aseguran que se implementan prácticas sostenibles, mejorando la reputación y confiabilidad ante clientes y socios.
            .col-sm-8.col-lg-5
              figure
                img(src='@/assets/curso/temas/tema2/16.png', alt='Imagen ilustrativa', data-aos="fade-left")

          .row.align-items-center.justify-content-center
            .col-sm-10.col-lg-7.col-xl-6.mb-5.mb-lg-0
              h4 Análisis costo-beneficio ambiental
              p.mb-4 Es una herramienta para incorporar los costos ambientales (externalidades) en la evaluación económica de decisiones logísticas. Así se consideran no solo los costos financieros directos, sino también el impacto ambiental asociado, favoreciendo opciones que generen beneficios económicos y ecológicos a largo plazo.
            .col-sm-8.col-lg-5
              figure
                img(src='@/assets/curso/temas/tema2/16.png', alt='Imagen ilustrativa', data-aos="fade-left")


</template>

<script>
export default {
  name: 'Tema2',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
